// Tracks whether the logged-in supplier is "live" (has completed onboarding and
// been activated by an admin). Set from gate-status at login and refreshed on the
// onboarding page. Used to restrict navigation to the KYC pages until the
// supplier is taken live.
import { bumpNavFlags } from "./navFlagStore";

const KEY = "supplier_is_live";

export const setSupplierLive = (isLive: boolean): void => {
  try {
    localStorage.setItem(KEY, isLive ? "true" : "false");
  } catch {
    /* localStorage unavailable — fail open */
  }
  // Tell the nav: the menu is built during render from the value above, so without
  // this the sidebar keeps whatever it read on its last render.
  bumpNavFlags();
};

// Defaults to true when unknown so we never accidentally lock a supplier out of
// the whole app on missing/early data; gate-status sets the real value at login.
export const isSupplierLive = (): boolean => {
  try {
    return localStorage.getItem(KEY) !== "false";
  } catch {
    return true;
  }
};

// Nav item key that stays available to a not-yet-live supplier (the KYC entry).
// The individual KYB steps live inside the onboarding page's own nav rail
// (components/onboarding/OnboardingSubnav), reached via this single entry.
export const KYC_MENU_KEYS = ["onboarding"];
